<template>
    <transition name="fade">
        <div
            v-if="product"
            class="Results Results--calculator"
            :class="{ 'Results--mobile': isMobile }"
        >

            <h2
                v-routing-animation="{speedModifier: 50}"
                class="Results-header">
                <span>{{ translation.calculate.result.heading }}</span>
            </h2>

            <div
                v-routing-animation="{speedModifier: 50, index: 2}"
                class="Results-selection"
                v-if="!isMobile">
                <hempel-selection :selection="selection"/>
            </div>

            <div
                class="Calculator"
                :class="{ 'Calculator--mobile': isMobile }"
            >
                <div class="Calculator-image">
                    <div class="Calculator-title">
                        <strong class="">{{ product.name || 'No name' }}</strong>
                        <strong class=""> {{ product.productId || 'No ID' }}</strong>
                    </div>
                    <img
                        :src="product.img || '/images/placeholder.png'"
                        alt="Bucket">

                    <div
                        class="Calculator-links"
                        :class="{ 'Calculator-links--desktop': !isMobile }"
                    >
                        <hempel-link
                            v-routing-animation="{speedModifier: 50, index: 2}"
                            @click="openOverlay('recommendation')"
                            :label="translation.calculate.result.recommendation.title"
                            icon="email"
                            v-if="!isMobile"
                            class="Calculator-link"/>
                        <hempel-link
                            v-routing-animation="{speedModifier: 50, index: 2}"
                            @click="openOverlay('feedback')"
                            :label="translation.calculate.result.feedback.title"
                            icon="questionMark"
                            v-if="!isMobile"
                            class="Calculator-link"/>
                    </div>
                    <span class="Calculator-amount">
                        {{ roundUpQuarter(isUs ? litersToGallons(calculatedVolumeAntifouling) : calculatedVolumeAntifouling) }}
                        {{ volumeMeasurementUnitLabelBig }}
                    </span>
                </div>

                <div
                    v-if="productFromAPI"
                    class="Calculator-header">
                    <div class="Calculator-titleWrapper">
                        <span class="Calculator-headerCategory">{{ product.position }}</span>
                        <strong class="Calculator-headerName">{{ product.name }}</strong>
                    </div>

                    <div
                        class="Calculator-summary--desktop"
                    >
                        <span class="Calculator-amount">
                            {{ roundUpQuarter(isUs ? litersToGallons(calculatedVolumeAntifouling) : calculatedVolumeAntifouling) }}
                            {{ volumeMeasurementUnitLabelBig }}
                        </span>

                        <div
                            class="Calculator-summaryHeadline"
                            v-if="product.productId === '77450' || product.productId === '77222'">{{ translation.calculate.result.suggestedAmountTwoCoats }}</div>
                        <div
                            class="Calculator-summaryHeadline"
                            v-else>{{ translation.calculate.result.suggestedAmount }}</div>

                        <div
                            v-if="suggestedAmountBig"
                            class="Calculator-summaryItem">
                            <hempel-combination
                                :quantity="suggestedAmountBig"
                                :size="volumeMeasurementUnitBig"
                                icon="antifoulingBucket"/>
                        </div>
                        <div
                            v-if="suggestedAmountSmall && suggestedAmountBig"
                            class="Calculator-summaryItem--faded">+</div>
                        <div
                            v-if="suggestedAmountSmall"
                            class="Calculator-summaryItem">
                            <hempel-combination
                                :quantity="suggestedAmountSmall"
                                :size="volumeMeasurementUnitSmall"
                                icon="antifoulingCan"/>
                        </div>

                    </div>
                </div>

                <div
                    class="Calculator-summary"
                >

                    <div
                        class="Calculator-summaryHeadline"
                        v-if="product.productId === '77450' || product.productId === '77222'">{{ translation.calculate.result.suggestedAmountTwoCoats }}</div>
                    <div
                        class="Calculator-summaryHeadline"
                        v-else>{{ translation.calculate.result.suggestedAmount }}</div>

                    <div class="Calculator-summaryCans">
                        <div
                            v-if="suggestedAmountBig"
                            class="Calculator-summaryItem">
                            <hempel-combination
                                :quantity="suggestedAmountBig"
                                :size="volumeMeasurementUnitBig"
                                icon="antifoulingBucket"/>
                        </div>
                        <div
                            v-if="suggestedAmountSmall && suggestedAmountBig"
                            class="Calculator-summaryItem--faded">+</div>
                        <div
                            v-if="suggestedAmountSmall"
                            class="Calculator-summaryItem">
                            <hempel-combination
                                :quantity="suggestedAmountSmall"
                                :size="volumeMeasurementUnitSmall"
                                icon="antifoulingCan"/>
                        </div>
                    </div>
                </div>

                <div class="Calculator-divider">+</div>

                <div
                    class="Calculator-content"
                    v-routing-animation="{speedModifier: 50, index: 2}">
                    <hempel-primer-silic-one
                        :volume="calculatedVolumePrimer"
                        :small="calculatedVolumePrimerSmall"
                        v-if="product.productId === '77450'"
                    />
                    <hempel-primer-hempaspeed
                        :volume="calculatedVolumePrimer"
                        :small="calculatedVolumePrimerSmall"
                        v-else-if="product.productId === '77222'"
                    />
                    <hempel-primer
                        :volume="calculatedVolumePrimer"
                        :small="calculatedVolumePrimerSmall"
                        v-else
                    />
                </div>
                <div class="Calculator-content">
                    <br>
                    <hempel-button
                        class="Calculator-whereToBuy"
                        @click="openRetailers()"
                        :label="translation.calculate.result.whereToBuy"
                        primary
                        v-if="checkPaintLocation()"
                    />

                    <br>
                    <div class="Calculator-links">
                        <hempel-link
                            v-routing-animation="{speedModifier: 100, index: 4}"
                            @click="openOverlay('recommendation')"
                            :label="translation.calculate.result.recommendation.title"
                            icon="email"
                            v-if="isMobile"
                            class="Calculator-link"/>
                        <hempel-link
                            v-routing-animation="{speedModifier: 100, index: 4}"
                            @click="openOverlay('feedback')"
                            :label="translation.calculate.result.feedback.title"
                            icon="questionMark"
                            v-if="isMobile"
                            class="Calculator-link"/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
/* eslint-disable no-case-declarations */
import HempelButton from '@/components/shared/button/Button'
import HempelLink from '@/components/shared/link/Link'
import HempelSelection from '@/views/result/ResultSelection'
import HempelPrimer from '@/views/result/ResultPrimer'
import HempelPrimerSilicOne from '@/views/result/ResultPrimerSilicOne'
import HempelPrimerHempaspeed from '@/views/result/ResultPrimerHempaspeed'
import HempelCombination from '@/components/shared/combination/Combination'

export default {
    data() {
        return {
            gotProduct: false
        }
    },
    watch: {
        product() {
            this.gotProduct = true
        },
        gotProduct() {
            this.updateAnalytics()
        }
    },
    computed: {
        product() {
            return this.getProduct
        },
        selection() {
            return [
                {
                    label: this.translation.calculate.result.selection.country,
                    value: this.translation.find.answers.paintLocation[0].countries.filter(
                        item => item.value === this.$route.query.paintLocation
                    )[0].label,
                    action: () => {
                        this.switchAction(['paintLocation', 'antifouling'])
                    }
                },
                {
                    label: this.translation.calculate.result.selection.antifouling,
                    value: this.product.name || '',
                    action: () => {
                        this.switchAction(['antifouling'])
                    }
                },
                {
                    label: this.translation.calculate.result.selection.type,
                    value: this.translation.find.answers.type.filter(
                        item => item.value === this.$route.query.type
                    )[0].label,
                    action: () => {
                        this.switchAction(['type', 'keelType', 'dimensions'])
                    }
                },
                {
                    label: this.translation.calculate.result.selection.keelType,
                    value: this.$route.query.keelType
                        ? this.translation.calculate.answers.keelType.filter(
                              item => item.value === this.$route.query.keelType
                          )[0].label
                        : null,
                    action: () => {
                        this.switchAction(['keelType', 'dimensions'])
                    }
                },
                {
                    label: this.translation.calculate.result.selection.dimensions,
                    value: this.dimensionFormater(this.$route.query.dimensions),
                    action: () => {
                        this.switchAction(['dimensions'])
                    }
                }
            ].filter(item => item.value)
        },
        dimensionFormater() {
            return dimensions => {
                const d = dimensions.split('-')
                if (!d[1] && !d[2] && !d[3]) {
                    return `${d[4]} m2`
                }
                return `${[d[1], d[2], d[3], d[4]].join(' – ')} ${d[0]}`
            }
        },
        calculatedVolumeAntifouling() {
            return this.roundUp(this.calculateVolume('antifouling'))
        },
        suggestedAmountBig() {
            const packaging = this.product.value === '77450' ? 2.5 : 2.25 // If Silic One then 2.5
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? Math.floor(this.roundUp(this.calculateVolume('antifouling')) * 0.264172 / 0.5)
                : Math.floor(this.roundUp(this.calculateVolume('antifouling')) / packaging)
        },
        suggestedAmountSmall() {
            const packaging = this.product.value === '77450' ? 2.5 : 2.25 // If Silic One then 2.5
            // eslint-disable-next-line no-nested-ternary
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? this.suggestedAmountBig * 0.5 >
                  this.litersToGallons(this.calculatedVolumeAntifouling)
                    ? null
                    : 1
                : Math.ceil(
                      (this.roundUp(this.calculateVolume('antifouling')) -
                          this.suggestedAmountBig * packaging) /
                          0.75
                  )
        },
        calculatedVolumePrimer() {
            return this.roundUp(this.calculateVolume('primer'))
        },
        calculatedVolumePrimerSmall() {
            return Math.ceil(this.roundUp(this.calculateVolume('primer')) / 0.75)
        },
        isUs() {
            return (
                this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
            )
        },
        volumeMeasurementUnitSmall() {
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? '0.25gal'
                : '750ml'
        },
        volumeMeasurementUnitBig() {
            const packaging = this.product.value === '77450' ? '2.5L' : '2.25L' // If Silic One then 2.5
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? '0.5gal'
                : packaging
        },
        volumeMeasurementUnitLabelBig() {
            return this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
                ? 'gal'
                : 'L'
        },
        getPrimersData() {
            const primers = []

            const primerTexts = document.querySelectorAll('.ResultPrimer-copy')
            const primerTitles = document.querySelectorAll('.ResultPrimer-title')

            const primerAmount = document.querySelectorAll('.ResultPrimer-amount')

            const quantityBig = document.querySelectorAll(
                '.hempel-combination-big .Combination-quantity'
            )
            const quantitySmall = document.querySelectorAll(
                '.hempel-combination-small .Combination-quantity, .hempel-combination-small .combination-small-0'
            )

            primerTexts.forEach((primerText, index) => {
                primers.push({
                    title: primerTitles[index].innerHTML,
                    text: primerText.innerHTML.replace(/<\/?[^>]+(>|$)/g, ' '),
                    amount: primerAmount[index].innerHTML,
                    quantityBig: quantityBig[index].innerHTML,
                    quantitySmall: quantitySmall[index].innerHTML
                })
            })

            return primers
        }
    },
    methods: {
        litersToGallons(liter) {
            return (liter / 3.785).toFixed(2)
        },
        milliliterToQuarts(milliliter) {
            return milliliter * (0.00105669).toFixed(2)
        },
        checkPaintLocation() {
            if (this.$route.query.paintLocation == 'el-GR') return false
            return true
        },
        openRetailers() {
            if (this.$route.query.paintLocation == 'da-DK') {
                window.open('https://www.hempelyacht.dk/da-DK/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'en-GB') {
                window.open('https://www.hempelyacht.com/en-GB/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'en-US') {
                window.open('https://www.hempelyacht.com/en-us/where-to-buy', '_blank')
            }
            if (this.$route.query.paintLocation == 'en-CA') {
                window.open(
                    'https://www.hempelyacht.com/en-us/where-to-buy/canada-retailers',
                    '_blank'
                )
            }
            if (this.$route.query.paintLocation == 'es-ES') {
                window.open('https://www.hempelyacht.es/es-ES/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'hr-HR') {
                window.open('https://www.hempelyacht.hr/hr-HR/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'fi-FI') {
                window.open('https://www.hempelyacht.fi/fi-FI/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'de-DE') {
                window.open('https://www.hempelyacht.de/de-DE/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'nb-NO') {
                window.open('https://www.hempelyacht.no/nb-NO/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'nl-NL') {
                window.open('https://www.hempelyacht.nl/nl-NL/retailers', '_blank')
            }
            if (
                this.$route.query.paintLocation == 'sv-SE_e' ||
                this.$route.query.paintLocation == 'sv-SE_w' ||
                this.$route.query.paintLocation == 'sv-SE_l'
            ) {
                window.open('https://www.hempelyacht.se/sv-SE/retailers', '_blank')
            }
        },
        updateAnalytics() {
            this.dataLayerAdd(
                { type: 'virtualPageview' },
                `/calculate-volume/end/${this.product.position}/${this.product.name}-${
                    this.product.productId
                }`
            )
        },
        switchAction(ignoreValues) {
            const { query } = this.$route
            ignoreValues = ignoreValues || []
            ignoreValues.forEach(ignoreValue => delete query[ignoreValue])
            this.$router.push({ path: this.$route.path.split('_')[0], query })
        },
        calculateVolume(type) {
            if (!this.getSelectedProduct || !this.getSelectedProduct.coverage) {
                return 0
            }

            const boatType = this.$route.query.type
            const keel = this.$route.query.keelType || null
            const coverage = this.getSelectedProduct.coverage
            const { dimensions } = this.$route.query

            let volume

            if (
                !dimensions.split('-')[1] &&
                !dimensions.split('-')[2] &&
                !dimensions.split('-')[3] &&
                dimensions.split('-')[4]
            ) {
                // for dimensions in m2
                if (type === 'antifouling') {
                    volume = dimensions.split('-')[4] / coverage
                } else {
                    volume = dimensions.split('-')[4] / 7.8
                }
            } else {
                // for individual dimensions
                const unit = dimensions.split('-')[0]
                const low =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[1] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[1] * 0.3048).toFixed(2))
                const beam =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[2] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[2] * 0.3048).toFixed(2))
                const draft =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[3] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[3] * 0.3048).toFixed(2))

                if (type === 'antifouling') {
                    if (boatType !== 'sailing') {
                        volume = low * (beam + draft) * 0.85 / coverage
                    } else
                        volume =
                            keel === 'fin'
                                ? low * (beam + draft) * 0.5 / coverage
                                : low * (beam + draft) * 0.75 / coverage

                    // for primers
                } else if (boatType !== 'sailing') {
                    volume = low * (beam + draft) * 0.85 / 7.8
                } else
                    volume =
                        keel === 'fin'
                            ? low * (beam + draft) * 0.5 / 7.8
                            : low * (beam + draft) * 0.75 / 7.8
            }

            return volume
        },
        roundUp(number) {
            return Math.ceil(number * 2) / 2
            // return Math.ceil(4 * number) / 4
        },
        roundUpQuarter(number) {
            return Math.ceil(4 * number) / 4
        },
        goToMap() {
            this.$router.push({
                name: 'map',
                params: { country: this.$route.query.paintLocation }
            })
        },
        scrollScreen() {
            setTimeout(() => {
                this.$scrollTo(`.Header`, this.scrollOptions)
            }, 200)
        },
        openOverlay(type) {
            switch (type) {
                case 'feedback':
                    this.setFeedback(true)
                    break
                case 'recommendation':
                    const product = {
                        id: this.product.productId,
                        title: this.product.name,
                        type: this.capitalizeFirstLetter(this.product.position || ''),
                        image:
                            this.product.img ||
                            'http://www.yachtpaintcalculator.com/images/placeholder.png',
                        amount: `${this.calculatedVolumeAntifouling}L`,
                        suggested: {
                            small: {
                                quantity: this.suggestedAmountSmall,
                                size: '750ml'
                            },
                            large: {
                                quantity: this.suggestedAmountBig,
                                size: this.product.productId === '77450' ? '2.5L' : '2.25L'
                            }
                        },
                        primers: this.getPrimersData.map(primer => ({
                            title: primer.title,
                            text: primer.text,
                            amount: primer.amount,
                            small: {
                                quantity: primer.quantitySmall,
                                size: '750ml'
                            },
                            large: {
                                quantity: primer.quantityBig,
                                size: '2.25L'
                            }
                        }))
                    }
                    this.setRecommendation(product)
                    break
                case 'map':
                    this.setMap(true)
                    break
                default:
                    break
            }
        }
    },
    components: {
        HempelButton,
        HempelLink,
        HempelSelection,
        HempelPrimer,
        HempelPrimerSilicOne,
        HempelPrimerHempaspeed,
        HempelCombination
    },
    beforeMount() {
        this.scrollScreen()
    },
    mounted() {
        this.updateAnalytics()
        this.getPrimersData()
    }
}
</script>
